import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { ReactNode } from 'react';

type ThemePerformanceSectionContentProps = {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  error: Error | null;
  children: ReactNode;
};

export const ThemePerformanceSectionContent = ({
  isLoading,
  isError,
  isEmpty,
  error,
  children,
}: ThemePerformanceSectionContentProps) => {
  if (isLoading) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '248px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  if (isError || isEmpty) {
    throw new Error(error?.message);
  }

  return <>{children}</>;
};
